import { render, staticRenderFns } from "./YourApplicationPage.vue?vue&type=template&id=10dbdbe7&scoped=true&"
import script from "./YourApplicationPage.vue?vue&type=script&lang=js&"
export * from "./YourApplicationPage.vue?vue&type=script&lang=js&"
import style0 from "./YourApplicationPage.vue?vue&type=style&index=0&id=10dbdbe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dbdbe7",
  null
  
)

export default component.exports